import { render, staticRenderFns } from "./stock-request.vue?vue&type=template&id=15fd1bbe&"
import script from "./stock-request.vue?vue&type=script&lang=js&"
export * from "./stock-request.vue?vue&type=script&lang=js&"
import style0 from "./stock-request.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports